import React, { Component, Fragment } from "react";
import _get from "lodash/get";
import _set from "lodash/set";
import { PermissionServices, UtilityService } from "../../services";
import Button from "../../components/Buttons/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as mainAction from "../../redux/action/main";
// import productPic from '../../assets/images/no-product-image.png';
// import cloth from '../../assets/images/cloth/1.jpg';
import leftArrowImage from "../../assets/images/left-arrow.png";
import Rights from "../../services/common/rights";

//components
import Loading from "../../components/Common/Loading";

class EmployeRights extends Component {
  state = {
    moduleName: "",
    _id: "",
    name: "",
    allCheckBox: false,
    rights: Rights,
    isLoading: false
  };

  componentWillMount = () => {
    let { moduleName, _id } = this.props.location.state;
    this.setState({
      moduleName,
      _id
    });
  };

  async componentDidMount() {
    await this.setState({
      isLoading: true
    });
    if (this.props.location.state.moduleName == "ROLE") {
      await this.getRoleRights(this.props.location.state._id);
    }
    if (this.props.location.state.moduleName == "EMPLOYEE") {
      await this.getEmployeeRights(this.props.location.state._id);
    }
    await this.setState({
      isLoading: false
    });
  }

  onPageChange = path => {
    if (path.split(".").indexOf("create") !== -1) {
      let path1 = path.split(".");
      let path2 = path.split(".");
      let path3 = path1.splice(path.split(".").indexOf("create"), 1, "view");
      let path4 = path2.splice(path.split(".").indexOf("create"), 1, "edit");
      let viewChecked = document.getElementById(path1.join(".")).checked;
      let editChecked = document.getElementById(path2.join(".")).checked;
      let neededArray =
        !viewChecked && !editChecked
          ? [path, path1.join("."), path2.join(".")]
          : !viewChecked
            ? [path, path1.join(".")]
            : !editChecked
              ? [path, path2.join(".")]
              : [path];
      this.selectRights(neededArray);
    } else if (path.split(".").indexOf("edit") !== -1) {
      // let path1 = path.split('.');

      // let path2 = path1.splice(path.split('.').indexOf('create'),1,"view");
      // // let a = document.getElementById(path1.join('.')).checked;
      // let neededArray = (!document.getElementById(path).checked) ? [path] : [path,path1.join('.')]
      // this.selectRights(neededArray)
      let neededArray = [path];
      this.selectRights(neededArray);
    } else if (path.split(".").indexOf("view") !== -1) {
      let neededArray = [path];
      this.selectRights(neededArray);
    } else if (path.split(".").indexOf("delete") !== -1) {
      let neededArray = [path];
      this.selectRights(neededArray);
    }
  };
  selectRights = array => {
    const { rights } = this.state;
    array.map((data, i) => {
      _set(rights, data, !_get(rights, data));
      this.setState({ rights });
    });
  };
  selectAllCheckBox = () => {
    let rights = Rights;
    for (let i = 0; i < Object.keys(rights).length; i++) {
      let neededObj = rights[Object.keys(rights)[i]];
      if (
        Object.keys(rights)[i] === "fabric" ||
        Object.keys(rights)[i] === "trim" ||
        Object.keys(rights)[i] === "product" ||
        Object.keys(rights)[i] === "createIb" ||
        Object.keys(rights)[i] === "sampleRequest" ||
        Object.keys(rights)[i] === "permissions" ||
        Object.keys(rights)[i] === "reports" ||
        Object.keys(rights)[i] === "customer"
      ) {
        for (let j = 0; j < Object.keys(neededObj).length; j++) {
          let filteredObj = this.changeValue(
            neededObj[Object.keys(neededObj)[j]]
          );
          neededObj[Object.keys(neededObj)[j]] = filteredObj;
          rights[Object.keys(rights)[i]] = neededObj;
        }
      } else {
        let filteredObj = this.changeValue(neededObj);
        rights[Object.keys(rights)[i]] = filteredObj;
      }
      this.setState({ rights });
    }
  };
  changeValue = filteredObj => {
    filteredObj.web = {
      create: this.state.allCheckBox,
      view: this.state.allCheckBox,
      edit: this.state.allCheckBox,
      delete: this.state.allCheckBox
    };
    filteredObj.mobile = {
      create: this.state.allCheckBox,
      view: this.state.allCheckBox,
      edit: this.state.allCheckBox,
      delete: this.state.allCheckBox
    };

    return filteredObj;
  };
  renderCheckbox = path => {
    const { rights } = this.state;
    return (
      <td key={path}>
        <p>
          <input
            type="checkbox"
            id={path}
            class="filled-in"
            checked={_get(rights, path)}
            onChange={() => this.onPageChange(path)}
          />
          <label for={path} />
        </p>
      </td>
    );
  };

  UpdateRoleRights = async () => {
    await this.setState({
      isLoading: true
    });
    const { rights } = this.state;
    let obj = {
      _id: this.state._id,
      moduleName: this.state.moduleName
    };
    if (this.state.moduleName == "EMPLOYEE") {
      obj.userBasedRole = rights;
    } else {
      obj.rights = rights;
    }

    await PermissionServices.updateRights(obj)
      .then(response => {
        if (response.status == 200) {
          // let rights = this.state.moduleName == 'EMPLOYEE' ? obj.userBasedRole : obj.rights
          if (this.state.moduleName == "EMPLOYEE") {
            if (this.state._id === this.props._id)
              this.props.actions.updateRights(rights);
          }
          this.props.getalertMessage("success", response.text.message);
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      });
    await this.setState({
      isLoading: false
    });
  };

  getRoleRights = _id => {
    PermissionServices.getRoleRights(_id)
      .then(async response => {
        if (response.status === 200) {
          if (
            response.text.data.rights !== undefined &&
            response.text.data.rights !== null &&
            Object.keys(response.text.data.rights).length > 0
          ) {
            this.setState({
              rights: {
                ...this.state.rights,
                ...(await response.text.data.rights)
              }
            });
          }
          this.setState({
            name: response.text.data.roleName
          });
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  };
  getEmployeeRights = _id => {
    PermissionServices.getEmployeeRights(_id)
      .then(async response => {
        if (response.status === 200) {
          if (
            response.text.data.userBasedRole !== undefined &&
            response.text.data.userBasedRole !== null &&
            Object.keys(response.text.data.userBasedRole).length > 0
          ) {
            this.setState({
              rights: await response.text.data.userBasedRole
            });
          }
          this.setState({
            name: response.text.data.empName
          });
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  };

  render() {
    const { rights } = this.state;
    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div class="right-section">
          <div class="row nopadding bg-white">
            <div class="col-md-12 px-0 py-2 position-top-stick">
              <div className="col-md-12">
                <div className="col-md-4 nopadding text-left">
                  <span
                    className="p-2 cursor-hover"
                    onClick={e => this.props.history.goBack()}
                  >
                    <img width={"20px"} src={leftArrowImage} />
                  </span>
                </div>
                <div className="col-md-4 nopadding text-center">
                  <h6>{"Permissions"}</h6>
                </div>
                <div className="col-md-4 pull-right">
                  <div class="check-rights">
                    <p
                      class="manage_permissions"
                      onChange={() =>
                        this.setState(
                          { allCheckBox: !this.state.allCheckBox },
                          () => this.selectAllCheckBox(this.state.allCheckBox)
                        )
                      }
                    >
                      <input type="checkbox" class="filled-in" id="check-all" />
                      <label
                        for="check-all"
                        style={{
                          fontSize: "12px",
                          color: "#424242",
                          fontWeight: "lighter"
                        }}
                      >
                        Check All Rights
                      </label>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                {
                  <div className="col-md-6">
                    <div>
                      {" "}
                      <b>
                        {this.state.moduleName.charAt(0).toUpperCase() +
                          this.state.moduleName.substr(1).toLowerCase()}{" "}
                        Name{" "}
                      </b>
                      :{this.state.name}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col-md-12 nopadding">
              <div class="right-section-container">
                <div class="col-md-12 nopadding">
                  <div class="col-md-12 fixed-height-list">
                    <table class="striped manage_permissions white">
                      <thead>
                        <tr class="permission_head">
                          <th
                            data-field="module"
                            className="position-top-stick"
                          >
                            Modules
                          </th>
                          <th
                            data-field="submodules"
                            className="position-top-stick"
                          >
                            Sub Modules
                          </th>
                          <th
                            date-field="divisions"
                            className="position-top-stick"
                          >
                            Divisions
                          </th>
                          <th
                            colspan="4"
                            data-field="web"
                            className="position-top-stick"
                          >
                            <div className="th-flex">Web</div>
                            <div className="th-row">
                              <div>Create</div>
                              <div>View</div>
                              <div>Edit</div>
                              <div>Delete</div>
                            </div>
                          </th>
                          <th
                            colspan="4"
                            data-field="Mobile"
                            className="position-top-stick"
                          >
                            <div className="th-flex">
                              Mobile (Android & iOS)
                            </div>
                            <div className="th-row">
                              <div>Create</div>
                              <div>View</div>
                              <div>Edit</div>
                              <div>Delete</div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* <tr class="mod-header">
                              <th />
                              <th />
                              <th />
                              <th data-field="create">Create</th>
                              <th data-field="view">View</th>
                              <th data-field="edit">Edit</th>
                              <th data-field="delete">Delete</th>
                              <th data-field="create">Create</th>
                              <th data-field="view">View</th>
                              <th data-field="edit">Edit</th>
                              <th data-field="delete">Delete</th>
                            </tr> */}
                        {/* <tr> */}
                        <tr>
                          <td>Dashboard</td>
                          <td />
                          <td />
                          {this.renderCheckbox("dashboard.web.create")}
                          {this.renderCheckbox("dashboard.web.view")}
                          {this.renderCheckbox("dashboard.web.edit")}
                          {this.renderCheckbox("dashboard.web.delete")}
                          {this.renderCheckbox("dashboard.mobile.create")}
                          {this.renderCheckbox("dashboard.mobile.view")}
                          {this.renderCheckbox("dashboard.mobile.edit")}
                          {this.renderCheckbox("dashboard.mobile.delete")}
                        </tr>
                        <tr>
                          <td>Meeting Notes</td>
                          <td />
                          <td />
                          {this.renderCheckbox("meetingNotes.web.create")}
                          {this.renderCheckbox("meetingNotes.web.view")}
                          {this.renderCheckbox("meetingNotes.web.edit")}
                          {this.renderCheckbox("meetingNotes.web.delete")}
                          {this.renderCheckbox("meetingNotes.mobile.create")}
                          {this.renderCheckbox("meetingNotes.mobile.view")}
                          {this.renderCheckbox("meetingNotes.mobile.edit")}
                          {this.renderCheckbox("meetingNotes.mobile.delete")}
                        </tr>
                        <tr>
                          <td>Communication</td>
                          <td />
                          <td />
                          <td className="text-center">-</td>
                          <td>-</td>
                          <td className="text-center">-</td>
                          <td>-</td>
                          <td className="text-center">-</td>
                          <td>-</td>
                          <td className="text-center">-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <td rowspan="24">Development</td>
                          <td className="text-center">3D</td>
                          <td />
                          {this.renderCheckbox("cad.web.create")}
                          {this.renderCheckbox("cad.web.view")}
                          {this.renderCheckbox("cad.web.edit")}
                          {this.renderCheckbox("cad.web.delete")}
                          {this.renderCheckbox("cad.mobile.create")}
                          {this.renderCheckbox("cad.mobile.view")}
                          {this.renderCheckbox("cad.mobile.edit")}
                          {this.renderCheckbox("cad.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="6">Fabric</td>
                          <td>Fabric</td>
                          {this.renderCheckbox("fabric.fabric.web.create")}
                          {this.renderCheckbox("fabric.fabric.web.view")}
                          {this.renderCheckbox("fabric.fabric.web.edit")}
                          {this.renderCheckbox("fabric.fabric.web.delete")}
                          {this.renderCheckbox("fabric.fabric.mobile.create")}
                          {this.renderCheckbox("fabric.fabric.mobile.view")}
                          {this.renderCheckbox("fabric.fabric.mobile.edit")}
                          {this.renderCheckbox("fabric.fabric.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Yarn Dyed</td>
                          {this.renderCheckbox("fabric.yarnDyed.web.create")}
                          {this.renderCheckbox("fabric.yarnDyed.web.view")}
                          {this.renderCheckbox("fabric.yarnDyed.web.edit")}
                          {this.renderCheckbox("fabric.yarnDyed.web.delete")}
                          {this.renderCheckbox("fabric.yarnDyed.mobile.create")}
                          {this.renderCheckbox("fabric.yarnDyed.mobile.view")}
                          {this.renderCheckbox("fabric.yarnDyed.mobile.edit")}
                          {this.renderCheckbox("fabric.yarnDyed.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Embroidery</td>
                          {this.renderCheckbox("fabric.embroidery.web.create")}
                          {this.renderCheckbox("fabric.embroidery.web.view")}
                          {this.renderCheckbox("fabric.embroidery.web.edit")}
                          {this.renderCheckbox("fabric.embroidery.web.delete")}
                          {this.renderCheckbox(
                            "fabric.embroidery.mobile.create"
                          )}
                          {this.renderCheckbox("fabric.embroidery.mobile.view")}
                          {this.renderCheckbox("fabric.embroidery.mobile.edit")}
                          {this.renderCheckbox(
                            "fabric.embroidery.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Print</td>
                          {this.renderCheckbox("fabric.print.web.create")}
                          {this.renderCheckbox("fabric.print.web.view")}
                          {this.renderCheckbox("fabric.print.web.edit")}
                          {this.renderCheckbox("fabric.print.web.delete")}
                          {this.renderCheckbox("fabric.print.mobile.create")}
                          {this.renderCheckbox("fabric.print.mobile.view")}
                          {this.renderCheckbox("fabric.print.mobile.edit")}
                          {this.renderCheckbox("fabric.print.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Solid/Greige</td>
                          {this.renderCheckbox("fabric.solidGreige.web.create")}
                          {this.renderCheckbox("fabric.solidGreige.web.view")}
                          {this.renderCheckbox("fabric.solidGreige.web.edit")}
                          {this.renderCheckbox("fabric.solidGreige.web.delete")}
                          {this.renderCheckbox(
                            "fabric.solidGreige.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "fabric.solidGreige.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "fabric.solidGreige.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "fabric.solidGreige.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Supplier</td>
                          {this.renderCheckbox("fabric.supplier.web.create")}
                          {this.renderCheckbox("fabric.supplier.web.view")}
                          {this.renderCheckbox("fabric.supplier.web.edit")}
                          {this.renderCheckbox("fabric.supplier.web.delete")}
                          {this.renderCheckbox("fabric.supplier.mobile.create")}
                          {this.renderCheckbox("fabric.supplier.mobile.view")}
                          {this.renderCheckbox("fabric.supplier.mobile.edit")}
                          {this.renderCheckbox("fabric.supplier.mobile.delete")}
                        </tr>
                        <tr>
                          <td>B Number</td>
                          <td />
                          {this.renderCheckbox("bNumber.web.create")}
                          {this.renderCheckbox("bNumber.web.view")}
                          {this.renderCheckbox("bNumber.web.edit")}
                          {this.renderCheckbox("bNumber.web.delete")}
                          {this.renderCheckbox("bNumber.mobile.create")}
                          {this.renderCheckbox("bNumber.mobile.view")}
                          {this.renderCheckbox("bNumber.mobile.edit")}
                          {this.renderCheckbox("bNumber.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-center">Bulk Import</td>
                          <td />
                          {this.renderCheckbox("bulkImport.web.create")}
                          {this.renderCheckbox("bulkImport.web.view")}
                          {this.renderCheckbox("bulkImport.web.edit")}
                          {this.renderCheckbox("bulkImport.web.delete")}
                          {this.renderCheckbox("bulkImport.mobile.create")}
                          {this.renderCheckbox("bulkImport.mobile.view")}
                          {this.renderCheckbox("bulkImport.mobile.edit")}
                          {this.renderCheckbox("bulkImport.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-center">Print Fabric Number</td>
                          <td />
                          {this.renderCheckbox("printFabricNumber.web.create")}
                          {this.renderCheckbox("printFabricNumber.web.view")}
                          {this.renderCheckbox("printFabricNumber.web.edit")}
                          {this.renderCheckbox("printFabricNumber.web.delete")}
                          {this.renderCheckbox(
                            "printFabricNumber.mobile.create"
                          )}
                          {this.renderCheckbox("printFabricNumber.mobile.view")}
                          {this.renderCheckbox("printFabricNumber.mobile.edit")}
                          {this.renderCheckbox(
                            "printFabricNumber.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="2" className="text-center">
                            Trim
                          </td>
                          <td className="text-left">Tirm</td>
                          {this.renderCheckbox("trim.trim.web.create")}
                          {this.renderCheckbox("trim.trim.web.view")}
                          {this.renderCheckbox("trim.trim.web.edit")}
                          {this.renderCheckbox("trim.trim.web.delete")}
                          {this.renderCheckbox("trim.trim.mobile.create")}
                          {this.renderCheckbox("trim.trim.mobile.view")}
                          {this.renderCheckbox("trim.trim.mobile.edit")}
                          {this.renderCheckbox("trim.trim.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Supplier</td>
                          {this.renderCheckbox("trim.supplier.web.create")}
                          {this.renderCheckbox("trim.supplier.web.view")}
                          {this.renderCheckbox("trim.supplier.web.edit")}
                          {this.renderCheckbox("trim.supplier.web.delete")}
                          {this.renderCheckbox("trim.supplier.mobile.create")}
                          {this.renderCheckbox("trim.supplier.mobile.view")}
                          {this.renderCheckbox("trim.supplier.mobile.edit")}
                          {this.renderCheckbox("trim.supplier.mobile.delete")}
                        </tr>
                        <tr>
                          <td>Sourcing</td>
                          <td />
                          {this.renderCheckbox("sourcing.web.create")}
                          {this.renderCheckbox("sourcing.web.view")}
                          {this.renderCheckbox("sourcing.web.edit")}
                          {this.renderCheckbox("sourcing.web.delete")}
                          {this.renderCheckbox("sourcing.mobile.create")}
                          {this.renderCheckbox("sourcing.mobile.view")}
                          {this.renderCheckbox("sourcing.mobile.edit")}
                          {this.renderCheckbox("sourcing.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="11">Product</td>
                          <td>Product</td>
                          {this.renderCheckbox("product.product.web.create")}
                          {this.renderCheckbox("product.product.web.view")}
                          {this.renderCheckbox("product.product.web.edit")}
                          {this.renderCheckbox("product.product.web.delete")}
                          {this.renderCheckbox("product.product.mobile.create")}
                          {this.renderCheckbox("product.product.mobile.view")}
                          {this.renderCheckbox("product.product.mobile.edit")}
                          {this.renderCheckbox("product.product.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Sample</td>
                          {this.renderCheckbox("product.sample.web.create")}
                          {this.renderCheckbox("product.sample.web.view")}
                          {this.renderCheckbox("product.sample.web.edit")}
                          {this.renderCheckbox("product.sample.web.delete")}
                          {this.renderCheckbox("product.sample.mobile.create")}
                          {this.renderCheckbox("product.sample.mobile.view")}
                          {this.renderCheckbox("product.sample.mobile.edit")}
                          {this.renderCheckbox("product.sample.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Pattern</td>
                          {this.renderCheckbox("product.pattern.web.create")}
                          {this.renderCheckbox("product.pattern.web.view")}
                          {this.renderCheckbox("product.pattern.web.edit")}
                          {this.renderCheckbox("product.pattern.web.delete")}
                          {this.renderCheckbox("product.pattern.mobile.create")}
                          {this.renderCheckbox("product.pattern.mobile.view")}
                          {this.renderCheckbox("product.pattern.mobile.edit")}
                          {this.renderCheckbox("product.pattern.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Garment Tech</td>
                          {this.renderCheckbox(
                            "product.garmentTech.web.create"
                          )}
                          {this.renderCheckbox("product.garmentTech.web.view")}
                          {this.renderCheckbox("product.garmentTech.web.edit")}
                          {this.renderCheckbox(
                            "product.garmentTech.web.delete"
                          )}
                          {this.renderCheckbox(
                            "product.garmentTech.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "product.garmentTech.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "product.garmentTech.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "product.garmentTech.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Fabric</td>
                          {this.renderCheckbox("product.fabric.web.create")}
                          {this.renderCheckbox("product.fabric.web.view")}
                          {this.renderCheckbox("product.fabric.web.edit")}
                          {this.renderCheckbox("product.fabric.web.delete")}
                          {this.renderCheckbox("product.fabric.mobile.create")}
                          {this.renderCheckbox("product.fabric.mobile.view")}
                          {this.renderCheckbox("product.fabric.mobile.edit")}
                          {this.renderCheckbox("product.fabric.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Trim</td>
                          {this.renderCheckbox("product.trim.web.create")}
                          {this.renderCheckbox("product.trim.web.view")}
                          {this.renderCheckbox("product.trim.web.edit")}
                          {this.renderCheckbox("product.trim.web.delete")}
                          {this.renderCheckbox("product.trim.mobile.create")}
                          {this.renderCheckbox("product.trim.mobile.view")}
                          {this.renderCheckbox("product.trim.mobile.edit")}
                          {this.renderCheckbox("product.trim.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Embellishment</td>
                          {this.renderCheckbox(
                            "product.embellishment.web.create"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.web.view"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.web.edit"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.web.delete"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "product.embellishment.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Cutting</td>
                          {this.renderCheckbox("product.cutting.web.create")}
                          {this.renderCheckbox("product.cutting.web.view")}
                          {this.renderCheckbox("product.cutting.web.edit")}
                          {this.renderCheckbox("product.cutting.web.delete")}
                          {this.renderCheckbox("product.cutting.mobile.create")}
                          {this.renderCheckbox("product.cutting.mobile.view")}
                          {this.renderCheckbox("product.cutting.mobile.edit")}
                          {this.renderCheckbox("product.cutting.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Sewing</td>
                          {this.renderCheckbox("product.sewing.web.create")}
                          {this.renderCheckbox("product.sewing.web.view")}
                          {this.renderCheckbox("product.sewing.web.edit")}
                          {this.renderCheckbox("product.sewing.web.delete")}
                          {this.renderCheckbox("product.sewing.mobile.create")}
                          {this.renderCheckbox("product.sewing.mobile.view")}
                          {this.renderCheckbox("product.sewing.mobile.edit")}
                          {this.renderCheckbox("product.sewing.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Dispatch</td>
                          {this.renderCheckbox("product.dispatch.web.create")}
                          {this.renderCheckbox("product.dispatch.web.view")}
                          {this.renderCheckbox("product.dispatch.web.edit")}
                          {this.renderCheckbox("product.dispatch.web.delete")}
                          {this.renderCheckbox(
                            "product.dispatch.mobile.create"
                          )}
                          {this.renderCheckbox("product.dispatch.mobile.view")}
                          {this.renderCheckbox("product.dispatch.mobile.edit")}
                          {this.renderCheckbox(
                            "product.dispatch.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sign off</td>
                          {this.renderCheckbox("product.signOff.web.create")}
                          {this.renderCheckbox("product.signOff.web.view")}
                          {this.renderCheckbox("product.signOff.web.edit")}
                          {this.renderCheckbox("product.signOff.web.delete")}
                          {this.renderCheckbox("product.signOff.mobile.create")}
                          {this.renderCheckbox("product.signOff.mobile.view")}
                          {this.renderCheckbox("product.signOff.mobile.edit")}
                          {this.renderCheckbox("product.signOff.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="12">Style</td>
                          <td className="text-center">Style</td>
                          <td />
                          {this.renderCheckbox("style.web.create")}
                          {this.renderCheckbox("style.web.view")}
                          {this.renderCheckbox("style.web.edit")}
                          {this.renderCheckbox("style.web.delete")}
                          {this.renderCheckbox("style.mobile.create")}
                          {this.renderCheckbox("style.mobile.view")}
                          {this.renderCheckbox("style.mobile.edit")}
                          {this.renderCheckbox("style.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="9">Create IB</td>
                          <td>Create IB</td>
                          {this.renderCheckbox("createIb.createIb.web.create")}
                          {this.renderCheckbox("createIb.createIb.web.view")}
                          {this.renderCheckbox("createIb.createIb.web.edit")}
                          {this.renderCheckbox("createIb.createIb.web.delete")}
                          {this.renderCheckbox(
                            "createIb.createIb.mobile.create"
                          )}
                          {this.renderCheckbox("createIb.createIb.mobile.view")}
                          {this.renderCheckbox("createIb.createIb.mobile.edit")}
                          {this.renderCheckbox(
                            "createIb.createIb.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Order details</td>
                          {this.renderCheckbox(
                            "createIb.orderDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.orderDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Garment Process</td>
                          {this.renderCheckbox(
                            "createIb.garmentProcess.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.garmentProcess.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Fabric details</td>
                          {this.renderCheckbox(
                            "createIb.fabricDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.fabricDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Trim</td>
                          {this.renderCheckbox("createIb.trim.web.create")}
                          {this.renderCheckbox("createIb.trim.web.view")}
                          {this.renderCheckbox("createIb.trim.web.edit")}
                          {this.renderCheckbox("createIb.trim.web.delete")}
                          {this.renderCheckbox("createIb.trim.mobile.create")}
                          {this.renderCheckbox("createIb.trim.mobile.view")}
                          {this.renderCheckbox("createIb.trim.mobile.edit")}
                          {this.renderCheckbox("createIb.trim.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Embroidery</td>
                          {this.renderCheckbox(
                            "createIb.embroidery.web.create"
                          )}
                          {this.renderCheckbox("createIb.embroidery.web.view")}
                          {this.renderCheckbox("createIb.embroidery.web.edit")}
                          {this.renderCheckbox(
                            "createIb.embroidery.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.embroidery.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.embroidery.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.embroidery.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.embroidery.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Embellishment</td>
                          {this.renderCheckbox(
                            "createIb.embellishment.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.embellishment.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sealing details</td>
                          {this.renderCheckbox(
                            "createIb.sealingDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.sealingDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Other details</td>
                          {this.renderCheckbox(
                            "createIb.otherDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "createIb.otherDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td>SMV Calc. & Thread</td>
                          <td />
                          {this.renderCheckbox("smvCalcThread.web.create")}
                          {this.renderCheckbox("smvCalcThread.web.view")}
                          {this.renderCheckbox("smvCalcThread.web.edit")}
                          {this.renderCheckbox("smvCalcThread.web.delete")}
                          {this.renderCheckbox("smvCalcThread.mobile.create")}
                          {this.renderCheckbox("smvCalcThread.mobile.view")}
                          {this.renderCheckbox("smvCalcThread.mobile.edit")}
                          {this.renderCheckbox("smvCalcThread.mobile.delete")}
                        </tr>
                        <tr>
                          <td>Technical Issues</td>
                          <td />
                          {this.renderCheckbox("technicalIssues.web.create")}
                          {this.renderCheckbox("technicalIssues.web.view")}
                          {this.renderCheckbox("technicalIssues.web.edit")}
                          {this.renderCheckbox("technicalIssues.web.delete")}
                          {this.renderCheckbox("technicalIssues.mobile.create")}
                          {this.renderCheckbox("technicalIssues.mobile.view")}
                          {this.renderCheckbox("technicalIssues.mobile.edit")}
                          {this.renderCheckbox("technicalIssues.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="17">Sample Request</td>
                          <td rowspan="17" className="text-center">
                            Sample Request
                          </td>
                          <td className="text-left">Sample Request</td>
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleRequest.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sample</td>
                          {this.renderCheckbox(
                            "sampleRequest.sample.web.create"
                          )}
                          {this.renderCheckbox("sampleRequest.sample.web.view")}
                          {this.renderCheckbox("sampleRequest.sample.web.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.sample.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sample.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sample.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sample.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sample.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">3D</td>
                          {this.renderCheckbox("sampleRequest.cad.web.create")}
                          {this.renderCheckbox("sampleRequest.cad.web.view")}
                          {this.renderCheckbox("sampleRequest.cad.web.edit")}
                          {this.renderCheckbox("sampleRequest.cad.web.delete")}
                          {this.renderCheckbox(
                            "sampleRequest.cad.mobile.create"
                          )}
                          {this.renderCheckbox("sampleRequest.cad.mobile.view")}
                          {this.renderCheckbox("sampleRequest.cad.mobile.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.cad.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Fabric</td>
                          {this.renderCheckbox(
                            "sampleRequest.fabric.web.create"
                          )}
                          {this.renderCheckbox("sampleRequest.fabric.web.view")}
                          {this.renderCheckbox("sampleRequest.fabric.web.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.fabric.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.fabric.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.fabric.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.fabric.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.fabric.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Trim</td>
                          {this.renderCheckbox("sampleRequest.trim.web.create")}
                          {this.renderCheckbox("sampleRequest.trim.web.view")}
                          {this.renderCheckbox("sampleRequest.trim.web.edit")}
                          {this.renderCheckbox("sampleRequest.trim.web.delete")}
                          {this.renderCheckbox(
                            "sampleRequest.trim.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.trim.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.trim.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.trim.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Pattern</td>
                          {this.renderCheckbox(
                            "sampleRequest.pattern.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.pattern.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Cutting</td>
                          {this.renderCheckbox(
                            "sampleRequest.cutting.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.cutting.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sewing</td>
                          {this.renderCheckbox(
                            "sampleRequest.sewing.web.create"
                          )}
                          {this.renderCheckbox("sampleRequest.sewing.web.view")}
                          {this.renderCheckbox("sampleRequest.sewing.web.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.sewing.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sewing.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sewing.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sewing.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sewing.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Garment Tech</td>
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.garmentTech.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Embellishment</td>
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embellishment.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Embroidery</td>
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.embroidery.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Wash</td>
                          {this.renderCheckbox("sampleRequest.wash.web.create")}
                          {this.renderCheckbox("sampleRequest.wash.web.view")}
                          {this.renderCheckbox("sampleRequest.wash.web.edit")}
                          {this.renderCheckbox("sampleRequest.wash.web.delete")}
                          {this.renderCheckbox(
                            "sampleRequest.wash.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.wash.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.wash.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.wash.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Dispatch</td>
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.dispatch.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">QC</td>
                          {this.renderCheckbox("sampleRequest.QC.web.create")}
                          {this.renderCheckbox("sampleRequest.QC.web.view")}
                          {this.renderCheckbox("sampleRequest.QC.web.edit")}
                          {this.renderCheckbox("sampleRequest.QC.web.delete")}
                          {this.renderCheckbox(
                            "sampleRequest.QC.mobile.create"
                          )}
                          {this.renderCheckbox("sampleRequest.QC.mobile.view")}
                          {this.renderCheckbox("sampleRequest.QC.mobile.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.QC.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Marker</td>
                          {this.renderCheckbox(
                            "sampleRequest.marker.web.create"
                          )}
                          {this.renderCheckbox("sampleRequest.marker.web.view")}
                          {this.renderCheckbox("sampleRequest.marker.web.edit")}
                          {this.renderCheckbox(
                            "sampleRequest.marker.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.marker.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.marker.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.marker.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.marker.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Costing</td>
                          {this.renderCheckbox(
                            "sampleRequest.costing.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.costing.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sign off</td>
                          {this.renderCheckbox(
                            "sampleRequest.signoff.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.signoff.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td></td>
                          <td>Sample Tag</td>
                          <td className="text-left">Sample Tag</td>
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.web.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.web.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.web.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.web.delete"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "sampleRequest.sampleTag.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td>Costing</td>
                          <td />
                          <td />
                          {this.renderCheckbox("costing.web.create")}
                          {this.renderCheckbox("costing.web.view")}
                          {this.renderCheckbox("costing.web.edit")}
                          {this.renderCheckbox("costing.web.delete")}
                          {this.renderCheckbox("costing.mobile.create")}
                          {this.renderCheckbox("costing.mobile.view")}
                          {this.renderCheckbox("costing.mobile.edit")}
                          {this.renderCheckbox("costing.mobile.delete")}
                        </tr>
                        <tr>
                          <td>System</td>
                          <td />
                          <td />
                          {this.renderCheckbox("system.web.create")}
                          {this.renderCheckbox("system.web.view")}
                          {this.renderCheckbox("system.web.edit")}
                          {this.renderCheckbox("system.web.delete")}
                          {this.renderCheckbox("system.mobile.create")}
                          {this.renderCheckbox("system.mobile.view")}
                          {this.renderCheckbox("system.mobile.edit")}
                          {this.renderCheckbox("system.mobile.delete")}
                        </tr>
                        {/* <tr>
                          <td rowspan="24">System</td>
                          <td rowspan="5" className="text-center">
                            Fabric
                          </td>
                          <td className="text-left">Fabric</td>
                          {this.renderCheckbox(
                            "system.fabric.fabric.web.create"
                          )}
                          {this.renderCheckbox("system.fabric.fabric.web.view")}
                          {this.renderCheckbox("system.fabric.fabric.web.edit")}
                          {this.renderCheckbox(
                            "system.fabric.fabric.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.fabric.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.fabric.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.fabric.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.fabric.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">yarnDyed</td>
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.yarnDyed.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">print</td>
                          {this.renderCheckbox("system.fabric.print.web.view")}
                          {this.renderCheckbox("system.fabric.print.web.edit")}
                          {this.renderCheckbox(
                            "system.fabric.print.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.print.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.print.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.print.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.print.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.print.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">greigeDenim</td>
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.greigeDenim.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">supplier</td>
                          {this.renderCheckbox(
                            "system.fabric.supplier.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.fabric.supplier.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="2" className="text-center">
                            Trim
                          </td>
                          <td className="text-left">Trim</td>
                          {this.renderCheckbox("system.trim.trim.web.create")}
                          {this.renderCheckbox("system.trim.trim.web.view")}
                          {this.renderCheckbox("system.trim.trim.web.edit")}
                          {this.renderCheckbox("system.trim.trim.web.delete")}
                          {this.renderCheckbox(
                            "system.trim.trim.mobile.create"
                          )}
                          {this.renderCheckbox("system.trim.trim.mobile.view")}
                          {this.renderCheckbox("system.trim.trim.mobile.edit")}
                          {this.renderCheckbox(
                            "system.trim.trim.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Supplier</td>
                          {this.renderCheckbox(
                            "system.trim.supplier.web.create"
                          )}
                          {this.renderCheckbox("system.trim.supplier.web.view")}
                          {this.renderCheckbox("system.trim.supplier.web.edit")}
                          {this.renderCheckbox(
                            "system.trim.supplier.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.trim.supplier.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.trim.supplier.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.trim.supplier.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.trim.trim.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="1" className="text-center">
                            System Supplier
                          </td>
                          <td />
                          {this.renderCheckbox(
                            "system.systemSupplier.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.systemSupplier.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="2" className="text-center">
                            Style
                          </td>
                          <td className="text-left">Style</td>
                          {this.renderCheckbox("system.style.style.web.view")}
                          {this.renderCheckbox("system.style.style.web.edit")}
                          {this.renderCheckbox("system.style.style.web.create")}
                          {this.renderCheckbox("system.style.style.web.delete")}
                          {this.renderCheckbox(
                            "system.style.style.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.style.style.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.style.style.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.style.style.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">smv</td>
                          {this.renderCheckbox("system.style.smv.web.view")}
                          {this.renderCheckbox("system.style.smv.web.edit")}
                          {this.renderCheckbox("system.style.smv.web.create")}
                          {this.renderCheckbox("system.style.smv.web.delete")}
                          {this.renderCheckbox(
                            "system.style.smv.mobile.create"
                          )}
                          {this.renderCheckbox("system.style.smv.mobile.view")}
                          {this.renderCheckbox("system.style.smv.mobile.edit")}
                          {this.renderCheckbox(
                            "system.style.smv.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="5" className="text-center">
                            Customer
                          </td>
                          <td className="text-left">basic</td>
                          {this.renderCheckbox(
                            "system.customer.basic.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.basic.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">department</td>
                          {this.renderCheckbox(
                            "system.customer.department.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.department.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">staff</td>
                          {this.renderCheckbox(
                            "system.customer.staff.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.staff.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">miscellaneous</td>
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.miscellaneous.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">trimPack</td>
                          {this.renderCheckbox(
                            "system.customer.trimPack.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.customer.trimPack.mobile.delete"
                          )}
                        </tr>

                        <tr>
                          <td rowspan="5" className="text-center">
                            Costing
                          </td>
                          <td className="text-left">smokingShirring</td>
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.smokingShirring.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">embroideryCost</td>
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embroideryCost.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">
                            embellishmentCostDetails
                          </td>
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.embellishmentCostDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">
                            manufacturingCostDetails
                          </td>
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.manufacturingCostDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">costing</td>
                          {this.renderCheckbox(
                            "system.costing.costing.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.costing.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="3" className="text-center">
                            General
                          </td>
                          <td className="text-left">images</td>
                          {this.renderCheckbox(
                            "system.costing.images.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">bNumber</td>
                          {this.renderCheckbox(
                            "system.costing.bNumber.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.bNumber.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">sampleRequest</td>
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.sampleRequest.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td rowspan="1" className="text-center">
                            cad
                          </td>
                          <td />
                          {this.renderCheckbox(
                            "system.costing.images.web.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.web.delete"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "system.costing.images.mobile.delete"
                          )}
                        </tr>{" "}
                        ///////////////////////////// */}
                        {/* <tr></tr> */}
                        <tr>
                          <td rowspan="4">Customer</td>
                          <td className="text-center">Customer</td>
                          <td />
                          {this.renderCheckbox("customer.customer.web.create")}
                          {this.renderCheckbox("customer.customer.web.view")}
                          {this.renderCheckbox("customer.customer.web.edit")}
                          {this.renderCheckbox("customer.customer.web.delete")}
                          {this.renderCheckbox("customer.customer.mobile.create")}
                          {this.renderCheckbox("customer.customer.mobile.view")}
                          {this.renderCheckbox("customer.customer.mobile.edit")}
                          {this.renderCheckbox("customer.customer.mobile.delete")}
                        </tr>
                        <tr>
                        <td className="text-center">Customer - Department with POM</td>
                        <td />
                          {this.renderCheckbox("customer.withoutpoms.web.create")}
                          {this.renderCheckbox("customer.withoutpoms.web.view")}
                          {this.renderCheckbox("customer.withoutpoms.web.edit")}
                          {this.renderCheckbox("customer.withoutpoms.web.delete")}
                          {this.renderCheckbox("customer.withoutpoms.mobile.create")}
                          {this.renderCheckbox("customer.withoutpoms.mobile.view")}
                          {this.renderCheckbox("customer.withoutpoms.mobile.edit")}
                          {this.renderCheckbox("customer.withoutpoms.mobile.delete")}
                        </tr>
                        <tr>
                        <td className="text-center">Customer - Department only</td>
                        <td />
                          {this.renderCheckbox("customer.masterpom.web.create")}
                          {this.renderCheckbox("customer.masterpom.web.view")}
                          {this.renderCheckbox("customer.masterpom.web.edit")}
                          {this.renderCheckbox("customer.masterpom.web.delete")}
                          {this.renderCheckbox("customer.masterpom.mobile.create")}
                          {this.renderCheckbox("customer.masterpom.mobile.view")}
                          {this.renderCheckbox("customer.masterpom.mobile.edit")}
                          {this.renderCheckbox("customer.masterpom.mobile.delete")}
                        </tr>
                        <tr>
                        <td className="text-center">Customer - POM only</td>
                        <td />
                          {this.renderCheckbox("customer.garmentpom.web.create")}
                          {this.renderCheckbox("customer.garmentpom.web.view")}
                          {this.renderCheckbox("customer.garmentpom.web.edit")}
                          {this.renderCheckbox("customer.garmentpom.web.delete")}
                          {this.renderCheckbox("customer.garmentpom.mobile.create")}
                          {this.renderCheckbox("customer.garmentpom.mobile.view")}
                          {this.renderCheckbox("customer.garmentpom.mobile.edit")}
                          {this.renderCheckbox("customer.garmentpom.mobile.delete")}
                        </tr>
                        <tr>
                          <td rowspan="2">Permissions</td>
                          <td className="text-center">Employee Details</td>
                          <td />
                          {this.renderCheckbox(
                            "permissions.employeeDetails.web.create"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.web.view"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.web.edit"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.web.delete"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "permissions.employeeDetails.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td>Role Management</td>
                          <td />
                          {this.renderCheckbox(
                            "permissions.roleManagement.web.create"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.web.view"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.web.edit"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.web.delete"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "permissions.roleManagement.mobile.delete"
                          )}
                        </tr>
                        {/* <tr>
                          <td rowspan="2">Reports</td>
                          <td />
                          <td />
                          {this.renderCheckbox("reports.web.create")}
                          {this.renderCheckbox("reports.web.view")}
                          {this.renderCheckbox("reports.web.edit")}
                          {this.renderCheckbox("reports.web.delete")}
                          {this.renderCheckbox("reports.mobile.create")}
                          {this.renderCheckbox("reports.mobile.view")}
                          {this.renderCheckbox("reports.mobile.edit")}
                          {this.renderCheckbox("reports.mobile.delete")}
                        </tr> */}

                        <tr>
                          <td rowspan="17">Reports</td>
                          <td rowspan="17" className="text-center">
                            Reports
                          </td>
                          <td className="text-left">Fabric</td>
                          {this.renderCheckbox("reports.fabric.web.create")}
                          {this.renderCheckbox("reports.fabric.web.view")}
                          {this.renderCheckbox("reports.fabric.web.edit")}
                          {this.renderCheckbox("reports.fabric.web.delete")}
                          {this.renderCheckbox("reports.fabric.mobile.create")}
                          {this.renderCheckbox("reports.fabric.mobile.view")}
                          {this.renderCheckbox("reports.fabric.mobile.edit")}
                          {this.renderCheckbox("reports.fabric.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Dispatch</td>
                          {this.renderCheckbox("reports.dispatch.web.create")}
                          {this.renderCheckbox("reports.dispatch.web.view")}
                          {this.renderCheckbox("reports.dispatch.web.edit")}
                          {this.renderCheckbox("reports.dispatch.web.delete")}
                          {this.renderCheckbox(
                            "reports.dispatch.mobile.create"
                          )}
                          {this.renderCheckbox("reports.dispatch.mobile.view")}
                          {this.renderCheckbox("reports.dispatch.mobile.edit")}
                          {this.renderCheckbox(
                            "reports.dispatch.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Outstanding Customer</td>
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.outstandingCustomer.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">BNumber</td>
                          {this.renderCheckbox("reports.bNumber.web.create")}
                          {this.renderCheckbox("reports.bNumber.web.view")}
                          {this.renderCheckbox("reports.bNumber.web.edit")}
                          {this.renderCheckbox("reports.bNumber.web.delete")}
                          {this.renderCheckbox("reports.bNumber.mobile.create")}
                          {this.renderCheckbox("reports.bNumber.mobile.view")}
                          {this.renderCheckbox("reports.bNumber.mobile.edit")}
                          {this.renderCheckbox("reports.bNumber.mobile.delete")}
                        </tr>
                        <tr>
                          <td className="text-left">Process Completed</td>
                          {this.renderCheckbox(
                            "reports.processCompleted.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.processCompleted.mobile.delete"
                          )}
                        </tr>
                        {/* <tr>
                          <td className="text-left">Print/Yarn Dyed</td>
                          {this.renderCheckbox("reports.printYarn.web.create")}
                          {this.renderCheckbox("reports.printYarn.web.view")}
                          {this.renderCheckbox("reports.printYarn.web.edit")}
                          {this.renderCheckbox("reports.printYarn.web.delete")}
                          {this.renderCheckbox(
                            "reports.printYarn.mobile.create"
                          )}
                          {this.renderCheckbox("reports.printYarn.mobile.view")}
                          {this.renderCheckbox("reports.printYarn.mobile.edit")}
                          {this.renderCheckbox(
                            "reports.printYarn.mobile.delete"
                          )}
                        </tr> */}
                        <tr>
                          <td className="text-left">Samples Awaiting Materials</td>
                          {this.renderCheckbox(
                            "reports.processUpdates.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.processUpdates.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Fabric Price Pending</td>
                          {this.renderCheckbox(
                            "reports.fabPricePending.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.fabPricePending.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Fabric Library</td>
                          {this.renderCheckbox(
                            "reports.fabricLibrary.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.fabricLibrary.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sample Library</td>
                          {this.renderCheckbox(
                            "reports.sampleLibrary.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleLibrary.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sample Report By Process</td>
                          {this.renderCheckbox(
                            "reports.sampleProcesses.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleProcesses.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Bulk Updates For Dispatch</td>
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateDispatch.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Pattern Master Report</td>
                          {this.renderCheckbox(
                            "reports.patternMasterReport.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.patternMasterReport.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Process Updates</td>
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.bulkUpdateProcess.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Style Downloads</td>
                          {this.renderCheckbox(
                            "reports.styleDownloads.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.styleDownloads.mobile.delete"
                          )}
                        </tr>
                        <tr>
                          <td className="text-left">Sample Request Downloads</td>
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.web.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.web.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.web.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.web.delete"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.mobile.create"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.mobile.view"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.mobile.edit"
                          )}
                          {this.renderCheckbox(
                            "reports.sampleRequestDownloads.mobile.delete"
                          )}
                        </tr>

                      </tbody>
                    </table>
                  </div>
                  <div class="rights-btn text-center">
                    <button
                      type="button"
                      class="primary mr-3"
                      name="button"
                      onClick={() => this.UpdateRoleRights()}
                    >
                      Update Rights
                    </button>
                    <Button
                      buttonName="Back"
                      buttonType="cancel"
                      history={this.props.history}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    _id: state.main._id
  };
};
const mapDispatchToProps = dispatch => {
  return { actions: bindActionCreators(mainAction, dispatch) };
};
export default connect(mapStateToProps, mapDispatchToProps)(EmployeRights);


// WEBPACK FOOTER //
// ./src/pages/employeRights/page.js